import React from "react";
import { FileText, Download, ExternalLink, Calendar } from "lucide-react";

const SUBJECT_LABELS = {
  history: "History", geography: "Geography", polity: "Polity", economy: "Economy",
  environment: "Environment", "science-tech": "Science & Tech", ethics: "Ethics",
  "current-affairs": "Current Affairs",
};

export default function KitCard({ kit, onOpen }) {
  const date = kit.created_at ? new Date(kit.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
  return (
    <div className="gov-card flex flex-col transition-shadow hover:shadow-md" data-testid={`kit-card-${kit.id}`}>
      <div className="flex items-start gap-3 p-4">
        <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-[#1F3A68]/10">
          <FileText size={20} className="text-[#1F3A68]" />
        </div>
        <div className="min-w-0 flex-1">
          <span className="inline-block rounded-sm bg-[#1F3A68]/10 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#1F3A68]">
            {SUBJECT_LABELS[kit.subject] || kit.subject}
          </span>
          <h3 className="mt-1.5 font-serif text-base font-bold leading-snug text-[#0B2545]">{kit.title}</h3>
          {kit.description && <p className="mt-1 line-clamp-2 text-sm text-gray-600">{kit.description}</p>}
        </div>
      </div>
      <div className="mt-auto flex items-center justify-between border-t border-[#E5E7EB] px-4 py-2.5">
        <span className="flex items-center gap-1 text-xs text-gray-500">
          <Calendar size={12} /> {date}
        </span>
        <button
          onClick={() => onOpen(kit)}
          className="flex items-center gap-1.5 rounded-sm bg-[#1F3A68] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#0B2545]"
          data-testid={`kit-access-${kit.id}`}
        >
          {kit.external_link ? <ExternalLink size={13} /> : <Download size={13} />}
          {kit.external_link ? "Open Kit" : "Download"}
        </button>
      </div>
    </div>
  );
}
